import getApiUrl from './getApiUrl';

const apiUrl = getApiUrl(window);

export default apiUrl;
